import $http from './http'
import filter from '../utils/filter';

const statistic = {
  async getStatistics (params) {
    return $http('/statistics', {
      method: 'GET',
      params: { ...filter(params) }
    });
  },
  async getDetails (params) {
    return $http('/statistics/detail', {
      method: 'GET',
      params: { ...filter(params) }
    });
  }
};

export default statistic;



// WEBPACK FOOTER //
// ./src/api/statistic.js